module.exports = __webpack_public_path__ + "static/media/newcustomer1.476b9e37.svg";